import {clsx} from '@gfiber/typesmith';
import type {ReactNode} from 'react';
import styles from './FieldHints.module.scss';

export interface FieldHintsProps {
  helpText?: ReactNode;
  errorText?: ReactNode;
  helpTextClass?: string;
  errorTextClass?: string;
  helpTextId?: string;
  errorTextId?: string;
  className?: string;
}

export const FieldHints = ({
  helpText,
  errorText,
  helpTextClass,
  errorTextClass,
  helpTextId,
  errorTextId,
  className,
}: FieldHintsProps) => {
  if (!helpText && !errorText) {
    return null;
  }
  return (
    <div className={clsx(styles.hints, className)}>
      {helpText && (
        <div
          id={helpTextId}
          className={clsx(styles.helpText, helpTextClass)}
        >
          {helpText}
        </div>
      )}
      {errorText && (
        <div
          id={errorTextId}
          role="alert"
          className={clsx(styles.errorText, errorTextClass)}
        >
          {errorText}
        </div>
      )}
    </div>
  );
};
